import { Box, styled } from '@mui/material'
import Main from './Main'
import {
  useDeviceSize,
  useI18next,
  useLoginFlowEventListeners,
  useOnlineListener,
  useRouteFullScreenMode,
  useSetupSignalRConnection,
  useVisitorContext,
} from './hooks'
import {
  useApplicationInsightsEventListener,
  useSetAuthenticatedUser,
} from 'features/Telemetry/ApplicationInsights'
import CookieBanner from 'features/CookieBanner'
import CookieSettings from 'features/CookieSettings'
import VersionBanner from 'features/VersionBanner'
import { useSliceStateSelector } from 'slices/hooks'
import SystemInformation from './SystemInformation'
import FullScreenMain from './FullScreenMain'
import Header from './Header/Header'
import Footer from './Footer'
import { FetchContent } from 'App/Epi/FetchContent'
import { ContentContainer } from './ContentContainer'
import { Breadcrumbs } from 'App/components/Breadcrumbs'
import Preview from './Epi/Preview'
import Content from './Epi/Content'
import LanguageDisclaimerModal from './components/LanguageDisclaimer/LanguageDisclaimerModal'
import { useCachedContentQuery } from 'state/PublicWebApi'
import LoggedInFooter from './LoggedInNavigation/LoggedInFooter'
import { useRedirectToLogin } from 'utils/hooks'

const StyledBox = styled(Box)(() => ({
  minHeight: '100vh',
  display: 'flex',
  flex: '1 1 auto',
  flexFlow: 'column nowrap',
  width: '100%',
  backgroundColor: 'white',
}))

const App = () => {
  const isFullScreen = useRouteFullScreenMode()

  const { data: contentData, isLoading, isFetching } = useCachedContentQuery()
  const isPublicPage = contentData?.properties.isPublic

  const cookieSettingsOpen = useSliceStateSelector(
    (state) => state.slices.cookies.cookieSettingsOpen
  )

  const renderFooter = () => {
    if (!contentData || isLoading || isFetching) {
      return null
    }
    return isPublicPage ? <Footer /> : <LoggedInFooter />
  }
  useRedirectToLogin()
  useLoginFlowEventListeners()
  useSetupSignalRConnection()
  useDeviceSize()
  useOnlineListener()
  useApplicationInsightsEventListener()
  useSetAuthenticatedUser()
  useVisitorContext()
  useI18next()

  if (isFullScreen) {
    return (
      <StyledBox>
        <Preview />
        <VersionBanner />
        <CookieBanner />
        {cookieSettingsOpen && <CookieSettings />}
        <SystemInformation />
        <LanguageDisclaimerModal />

        <FetchContent>
          <FullScreenMain>
            <Content isFullScreen />
          </FullScreenMain>
        </FetchContent>
      </StyledBox>
    )
  }

  return (
    <StyledBox>
      <Preview />
      <VersionBanner />
      <CookieBanner />
      {cookieSettingsOpen && <CookieSettings />}
      <SystemInformation />
      <LanguageDisclaimerModal />

      <Header />
      <ContentContainer>
        <FetchContent>
          <Main>
            <>
              <Breadcrumbs />
              <Content isFullScreen={false} />
            </>
          </Main>
        </FetchContent>
      </ContentContainer>
      {renderFooter()}
    </StyledBox>
  )
}

export default App
